import React from "react";
import { MEDIA_URL } from '../../config/constants';

const BlogPostHero = ({ post }) => {
  return (
    <div className="blog-post-hero">
      <div className="blog-post-hero-container">
        <div className="blog-post-breadcrumb">
          <span className="breadcrumb-link">Home</span>
          <span className="breadcrumb-separator">•</span>
          <span className="breadcrumb-link">Blog</span>
          <span className="breadcrumb-separator">•</span>
          <span className="breadcrumb-current">{post.category}</span>
        </div>

        <div className="blog-post-header">
          <div className="blog-post-category-badge">
            <span className="category-text">{post.category}</span>
          </div>
          <h1 className="blog-post-title">{post.title}</h1>
          <p className="blog-post-subtitle">{post.subtitle}</p>

          <div className="blog-post-meta">
            <div className="post-author">
              <div className="author-avatar">
                <img
                  src={`${MEDIA_URL}/images/blog/blog-placeholder.webp`}
                  alt={post.author}
                  className="avatar-image"
                />
              </div>
              <div className="author-info">
                <span className="author-name">{post.author}</span>
                <span className="author-title">Travel Writer</span>
              </div>
            </div>

            <div className="post-details">
              <div className="detail-item">
                <div className="detail-icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 0C6.4087 0 4.88258 0.632141 3.75736 1.75736C2.63214 2.88258 2 4.4087 2 6C2 10.5 8 16 8 16C8 16 14 10.5 14 6C14 4.4087 13.3679 2.88258 12.2426 1.75736C11.1174 0.632141 9.5913 0 8 0ZM8 8C7.46957 8 6.96086 7.78929 6.58579 7.41421C6.21071 7.03914 6 6.53043 6 6C6 5.46957 6.21071 4.96086 6.58579 4.58579C6.96086 4.21071 7.46957 4 8 4C8.53043 4 9.03914 4.21071 9.41421 4.58579C9.78929 4.96086 10 5.46957 10 6C10 6.53043 9.78929 7.03914 9.41421 7.41421C9.03914 7.78929 8.53043 8 8 8Z"
                      fill="#009B31"
                    />
                  </svg>
                </div>
                <span className="detail-text">{post.date}</span>
              </div>

              <div className="detail-item">
                <div className="detail-icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1ZM12 8C12 8.13261 11.9473 8.25979 11.8536 8.35355C11.7598 8.44732 11.6326 8.5 11.5 8.5H8C7.86739 8.5 7.74021 8.44732 7.64645 8.35355C7.55268 8.25979 7.5 8.13261 7.5 8V4.5C7.5 4.36739 7.55268 4.24021 7.64645 4.14645C7.74021 4.05268 7.86739 4 8 4C8.13261 4 8.25979 4.05268 8.35355 4.14645C8.44732 4.24021 8.5 4.36739 8.5 4.5V7.5H11.5C11.6326 7.5 11.7598 7.55268 11.8536 7.64645C11.9473 7.74021 12 7.86739 12 8Z"
                      fill="#009B31"
                    />
                  </svg>
                </div>
                <span className="detail-text">{post.readTime}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-post-hero-image">
        <img src={post.heroImage} alt={post.title} className="hero-image" />
      </div>
    </div>
  );
};

export default BlogPostHero;
